// extracted by mini-css-extract-plugin
export default {"distribution":"bottomContent_distribution__dqRbj","groupRadio":"bottomContent_groupRadio__sZU7+","table":"bottomContent_table__PhEkP"};